import React, { FC } from "react";
import ManualStatus from "../ManualStatusButton";
import ManualPortalStatus from "../ManualPortalStatusButton";
import {
  IVisitStages,
  PortalStatusOption,
  StatusOption,
} from "../../../../interfaces/IPreAuth";
import { IFetchAllDetails } from "../../../../interfaces/IPatient";
import ClaimIDManuallyId from "../ClaimIDManuallyId";
import { Button, Card, Form } from "antd";
import { Steps } from "antd";
import Member from "./CghsTabs/Member";
import Visit from "./CghsTabs/Visit";
import Procedure from "./CghsTabs/Procedure";
import DocumentUpload from "./CghsTabs/DocumentUpload";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import PreAuthClaimManuallyID from "../PreAuthClaimManuallyID";
import { Spin } from "antd";
import DocumentUploadCghs from "../../PreAuthClaim/Documents/DocumentUploadCghs";
import ResponseDocumentUploadCghs from "./CghsTabs/ResponseDocumentUploadCghs";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import Treatment from "./CghsTabs/Treatment";

type PreAuthCghsProps = {
  patientStore: IFetchAllDetails | null;
  portalData: any;
  activeKey: number;
  formattedAdmissionType: Array<{ label: string; value: string }>;
  formattedAdmissionTypeOp: Array<{ label: string; value: string }>;
  formattedPatientDiagnosed: Array<{ label: string; value: string }>;
  formattedConsultationType: Array<{ label: string; value: string }>;
  formattedAccreditationOptions: Array<{ label: string; value: string }>;
  formattedTreatingDoctorsOptions: Array<{ label: string; value: string }>;
  formattedProcedureReferral: Array<{ label: string; value: string }>;
  formattedProceduresOptions: Array<{ label: string; value: string }>;
  handleGetProcedureAmount: CallableFunction;
  handleGetProcedureStrats: CallableFunction;
  procedureStrats: any;
  handleDeleteProcedure: CallableFunction;
  medcoDoctors: any;
  govtHospitalList: any;
  diagnosisList: any;
  form: any;
  handleSubmit: any;
  currentVisitStage: any;
  handleSaveAsDraft: any;
  handleUpdateAsDraft: any;
  documentTypes?: any;
  handleOpen?: any;
  documentRequestResponseDocuments: any;
  handleSaveData: any;
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks: string | null;
  }[];
  loading: boolean;
  handleFileChange: any;
  handleApprovePreAuth: any;
  isApprovedInitiated: boolean;
  isApproved: boolean;
  handleSaveConfirmationModal: any;
  getStarmarkOptions: any;
  uploadFileList: any;
  handleGetProcedureFromBill: any;
  isFetchingBillAuditProcedure: any;
};

const { Step } = Steps;

const PreAuthCghs: FC<PreAuthCghsProps> = (props) => {
  const { hasFunctionality } = useUserFunctionalities();
  const { auth } = useSelector((state: RootState) => state);
  const styles: Record<string, React.CSSProperties> = React.useMemo(() => ({
    mainContent: {
      //   border: "0.4px solid rgb(87, 87, 87)",
      gap: "15px",
      borderRadius: "16px",
      margin: "0px 0.5rem",
    },
    statusDesign: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "20px",
      minWidth: "676px",
      maxHeight: "36px",
    },
    borderDesign: {
      minHeight: "64px",
      background: "rgb(243, 243, 243)",
      padding: "12px 35px", // Removed the semicolon and fixed the gap
      gap: "42px", // Added the gap as a separate property
      borderRadius: "16px 16px 0px 0px", // Fixed camelCase
      borderBottom: "1px solid rgb(166, 166, 166)",
      fontWeight: "600",
      fontSize: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    filledBtn: {
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      textTransform: "uppercase",
      color: "white",
      marginRight: "0.8rem",
    },
    blankBtn: {
      color: "#008B8B",
      background: "white",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      marginRight: "0.8rem",
    },
    updateBtn: {
      position: "sticky",
      top: 0,
      backgroundColor: "white",
      zIndex: 998,
      padding: "10px 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    intimateSubmitBtn: {
      background: "#008B8B",
      // float: "right",
      marginRight: "0.8rem",
    },
    saveBtn: {
      color: "white",
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
    editBtn: {
      color: "#008B8B",
      background: "white",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
  }),[]);

  return (
    <div style={styles.mainContent}>
      <Form
        form={props.form}
        //   onFinish={handleSubmit}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%" }}
      >
        {props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
        "OP" ? (
          <Visit
            formattedAdmissionTypeOp={props?.formattedAdmissionTypeOp}
            form={props?.form}
            portalData={props?.portalData}
            patientStore={props?.patientStore}
            isApproved={props?.isApproved}
          />
        ) : (
          <Member
            formattedAdmissionType={props?.formattedAdmissionType}
            formattedPatientDiagnosed={props?.formattedPatientDiagnosed}
            medcoDoctors={props?.medcoDoctors}
            form={props?.form}
            portalData={props?.portalData}
            patientStore={props?.patientStore}
            isApproved={props?.isApproved}
          />
        )}

        <Treatment
          formattedConsultationType={props?.formattedConsultationType}
          govtHospitalList={props?.govtHospitalList}
          form={props?.form}
          diagnosisList={props?.diagnosisList}
          patientStore={props?.patientStore}
          portalData={props?.portalData}
          isApproved={props?.isApproved}
        />

        <Procedure
          patientDetails={props?.patientStore}
          formattedAccreditationOptions={props?.formattedAccreditationOptions}
          formattedTreatingDoctorsOptions={
            props?.formattedTreatingDoctorsOptions
          }
          formattedProcedureReferral={props?.formattedProcedureReferral}
          formattedProceduresOptions={props?.formattedProceduresOptions}
          handleGetProcedureAmount={props?.handleGetProcedureAmount}
          handleGetProcedureStrats={props?.handleGetProcedureStrats}
          procedureStrats={props?.procedureStrats}
          handleDeleteProcedure={props?.handleDeleteProcedure}
          form={props?.form}
          portalData={props?.portalData}
          isApproved={props?.isApproved}
          handleGetProcedureFromBill={props?.handleGetProcedureFromBill}
          isFetchingBillAuditProcedure={props?.isFetchingBillAuditProcedure}
        />
      </Form>

      {props?.loading ? (
        <div
          style={{
            margin: "auto",
            width: "100%,",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        props?.documentRequestResponseDocuments?.["requestedDocuments"]
          ?.length > 0 && (
          <DocumentUpload
            documentTypes={props?.documentTypes}
            documentUrls={props?.documentUrls}
            handleFileChange={props?.handleFileChange}
            handleOpen={props?.handleOpen}
            portalSubmission={
              props?.portalData?.casePreAuthCghs?.claimId ||
              props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
            }
            documentRequestResponseDocuments={
              props?.documentRequestResponseDocuments
            }
            getStarmarkOptions={props?.getStarmarkOptions}
            uploadFileList={props?.uploadFileList}
            isIntimated={
              props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.intimated
            }
          />
        )
      )}

      {props?.documentRequestResponseDocuments?.["responseDocuments"]?.length >
        0 && (
        <ResponseDocumentUploadCghs
          documentTypes={props?.documentTypes}
          documentUrls={props?.documentUrls}
          handleFileChange={props?.handleFileChange}
          handleOpen={props?.handleOpen}
          portalSubmission={
            props?.portalData?.casePreAuthCghs?.claimId ||
            props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
          }
          documentRequestResponseDocuments={
            props?.documentRequestResponseDocuments
          }
          handleSaveData={props?.handleSaveData}
          currentStage={props?.currentVisitStage}
          activeKey={props?.activeKey}
          uploadFileList={props?.uploadFileList}
        />
      )}

      {/* Navigation buttons */}
      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "30px",
          borderTop: "1px solid #D9D9D9",
          padding: "15px 20px",
        }}
      >
        {
          <>
            {!props?.portalData?.casePreAuthCghs?.claimId ? (
              <>
                {props?.portalData?.casePreAuthCghs?.id &&
                !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                  ?.initiated
                // && !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                //   ?.approved 
                // && !(
                //   auth?.role?.role == "FO_STAFF" &&
                //   props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                //     ?.intimated
                // ) 
                ? (
                  <div style={{ width: "16%" }}>
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        width: "100%",
                      }}
                      // onClick={props?.handleUpdateAsDraft}
                      onClick={() =>
                        props?.handleSaveConfirmationModal("update")
                      }
                    >
                      UPDATE
                    </Button>
                  </div>
                ) : (
                  !props?.portalData?.casePreAuthCghs?.id && (
                    <div style={{ width: "16%" }}>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                        }}
                        // onClick={props?.handleSaveAsDraft}
                        onClick={() =>
                          props?.handleSaveConfirmationModal("save")
                        }
                      >
                        SAVE
                      </Button>
                    </div>
                  )
                )}

                {hasFunctionality("casePreAuthIntimate") &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.intimated &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.initiated &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.approved && (
                    <div style={{ width: "16%" }}>
                      <Button
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                        }}
                        className="me-2"
                        // onClick={() => handleSaveIhx()}
                        onClick={() =>
                          props?.handleSaveConfirmationModal("intimate")
                        }
                      >
                        Send To QC
                      </Button>
                    </div>
                  )}

                {hasFunctionality("preAuthApprover") &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.initiated &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.approved &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted && (
                    <div style={{ width: "16%" }}>
                      <Button
                        loading={props?.isApprovedInitiated}
                        className="me-2"
                        // onClick={handleApprovePreAuth}
                        onClick={() =>
                          props?.handleSaveConfirmationModal("approve")
                        }
                        disabled={props?.isApproved}
                        // style={{ }}
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                          opacity: !props?.isApproved ? 1 : 0.5,
                          pointerEvents: !props?.isApproved ? "auto" : "none",
                        }}
                        // style={{display: "flex", alignItems: "center", background: "#008B8B", border: "1px solid #008B8B", boxShadow: "0px 2px 8px 0px #00000040", borderRadius: "10px", padding: "12px 25px"}}
                      >
                        QC Approve
                      </Button>
                    </div>
                  )}

                {hasFunctionality("casePreAuthSubmission") &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.initiated &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted && (
                    <div style={{ width: "16%" }}>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                        }}
                        onClick={props?.handleSubmit}
                      >
                        {props?.patientStore?.casesResponse
                          ?.integratedWithPortal
                          ? "Initiate"
                          : "Submit Manually"}
                      </Button>
                    </div>
                  )}
              </>
            ) : (
              <></>
            )}
          </>
        }
      </div>
    </div>
  );
};

export default React.memo(PreAuthCghs);
